import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-352dd176"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ccn-cookie-list" }

import { ICookieListEntry } from '../../common/interfaces/index.interface';
  import CookieListEntry from './CookieListEntry.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CookieList',
  props: {
    disabled: { type: Boolean, default: false },
    entries: { default: () => [] }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry) => {
      return (_openBlock(), _createBlock(CookieListEntry, {
        key: entry.internalIdentifier,
        disabled: _ctx.disabled,
        entry: entry,
        "onUpdate:activeSingleCookie": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(`update:active-single-cookie`, $event)))
      }, null, 8, ["disabled", "entry"]))
    }), 128))
  ]))
}
}

})